import _asyncToGenerator from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import './Events.css';
import React from 'react';
import { get, getDictionaryItem, injectImageResolution, pathJoin, getMediaHost, getTags, generatrURLFromTags, getFeaturedItemAndList, getTagsNames, canUseDOM, getPageThemeColors, getColorByTheme } from '../../utils';
import { useSitecoreContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import { ReactComponent as ChevronRight } from '../../resources/icons/IconChevronRightLight.svg';
import { ReactComponent as ChevronLeft } from '../../resources/icons/IconChevronLeftLight.svg';
import { ReactComponent as ChevronDown } from '../../resources/icons/IconChevronDownBlue.svg';
import CarouselProvider from '../atoms/CarouselProvider/CarouselProvider';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import RouterLink from '../atoms/RouterLink';
import getListing, { loadCategoryAlgoliaResults, formatTagsRuleToFilters, generateSeeMoreTagsFromRules, formatTagsRuleToFiltersOneByOne, isTagsRule } from '../../utils/getListing';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
// import Video from '../atoms/Video';
import ScrollAnimation from 'react-animate-on-scroll';
import EventBlock from './components/EventBlock';
import FeaturedEventBlock from './components/FeaturedEventBlock';
// import loadable from '@loadable/component';

//personlization

import { resolveListPersonalization } from '../../utils/resolveListPersonalization';
import { algoliaScoredCondition } from '../../utils/algoliaScoredCondition';
import { usePersonalizedList } from '@uniformdev/personalize-react';
// const Scrollbars = loadable(() => import('react-custom-scrollbars'), { ssr: false });
import { useInView } from 'react-intersection-observer';
import { convertToAnalyticObject } from '../../utils/analytics';
import { isNil } from '../../utils/IsNil';
var baseImage = process.env.REACT_APP_MEDIA_HOST || '';
var getFormatedDate = function getFormatedDate(date, lang) {
  return new Date(date).toLocaleDateString(lang === 'en' ? 'en-GB' : lang, {
    day: 'numeric',
    month: 'short'
  });
};
export var convertDate = function convertDate(startDate, endDate) {
  var lang = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'en-GB';
  var date = [];
  if (startDate) {
    date.push(getFormatedDate(startDate, lang));
  }
  if (endDate) {
    date.push(getFormatedDate(endDate, lang));
  }
  return date.join(' - ');
};
export var Events = function Events(_ref) {
  var params = _ref.params,
    fields = _ref.fields,
    route = _ref.route;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var currentLang = get(sitecoreContext, 'language');
  var _useInView = useInView({
      threshold: 1,
      triggerOnce: true
    }),
    _useInView2 = _slicedToArray(_useInView, 2),
    ref = _useInView2[0],
    inView = _useInView2[1];
  if (currentLang === 'no') {
    currentLang = 'nob';
  }
  var currentPageID = get(route, 'itemId', '').split('-').join('');

  // exempt the item of page of event in which Events applied
  var pageFilter = currentPageID ? "NOT objectID:".concat(currentPageID) : '';
  var contextItemId = get(fields, 'data.contextItem.id');
  var curtorListingPage = '';
  if (contextItemId) {
    curtorListingPage = "?curators.curators.Id=".concat(contextItemId);
  }
  var useCustomListingPage = get(fields, 'data.datasource.useCustomListingPage.jss.value');
  var considerPageLevelTags = get(fields, 'data.datasource.considerPageLevelTags.jss.value');
  var listingPageLink = get(fields, 'data.datasource.listingPageLink.jss.value.href');
  var discoverMoreLink = useCustomListingPage ? listingPageLink : get(fields, 'data.overviewButton.link.jss.value.href');
  var tagsRule = get(fields, 'data.datasource.tagsRule.jss.value');
  var isTagsRuleUsed = isTagsRule(tagsRule);
  var _React$useState = React.useState(true),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isVdsite = _React$useState2[0],
    setIsVdsite = _React$useState2[1];
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var countryItems = get(fields, 'data.countries.countryValues') || [];
  var moduleDictionary = get(fields, 'data.moduleDictionary');
  var dictionary = get(fields, 'data.dictionary');
  var defaultTitle = getDictionaryItem(moduleDictionary, 'EventsTitle');
  var multipleDates = getDictionaryItem(moduleDictionary, 'multipleDates') || 'Multiple days, next on';
  var hasItems = Boolean(get(fields, 'data.dictionary.dictionaryValues.length'));
  var showFeatured = get(fields, 'data.datasource.showFeatured.jss.value');
  var searchCount = showFeatured ? Number(get(params, 'SearchCount')) + 1 : Number(get(params, 'SearchCount'));
  var Color = get(params, 'Color', '');
  var BackgroundColorHex = get(params, 'BackgroundColorHex');
  var ColorHex = get(params, 'ColorHex');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var styleThemeHexColor = BackgroundColorHex ? {
    "--events-theme-hex-background-color": BackgroundColorHex,
    "--events-theme-hex-color": ColorHex
  } : {
    "--events-theme-hex-background-color": selectedPrimaryColor,
    "--events-theme-hex-color": getColorByTheme(selectedPrimaryColor)
  };
  var isInteractive = get(fields, 'data.datasource.interactive.jss.value');
  var isFilterByCurrentMonth = get(fields, 'data.datasource.filterByCurrentMonth.jss.value');
  var intents = get(fields, 'data.datasource.intents');
  var intentsLength = get(intents, 'targetItems.length');
  var overviewButton = get(fields, 'data.overviewButton');
  var overviewButtonTitle = get(fields, 'data.overviewButton.title.jss');
  var dictionaryValues = get(fields, 'data.dictionary.dictionaryValues');
  var items = hasItems ? dictionaryValues : [];
  var map = items.reduce(function (aggregator, currentValue) {
    return aggregator.set(currentValue.key.jss.value, currentValue.phrase.jss);
  }, new Map());
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var indexName = get(params, 'SearchIndex');
  var contextTags = getTags(get(fields, 'data.contextItem.tags'));
  var itemTags = get(fields, 'data.datasource') ? getTags(get(fields, 'data.datasource.tags')) : contextTags;
  var upcomingEventsIn = map.get('UpcomingEventsIn');
  var curatorsPick = map.get('CuratorsPick');
  var whereToFindUsIn = map.get('WhereToFindUsIn');
  var titleEventCheck = get(fields, 'data.datasource.title.jss.value');
  var titleEvent = get(fields, 'data.datasource.title.jss') || {
    value: defaultTitle
  };
  var theme = get(sitecoreContext, 'themesOfPage');
  var isPersonalised = sitecoreContext.isPersonalised;
  var divRef = /*#__PURE__*/React.createRef();
  var scrollRef = /*#__PURE__*/React.createRef();
  var curatorsPickCopy = get(curatorsPick, 'value');
  var currentMonth = new Date().getMonth();
  var months = new Array(12).fill(null).map(function (val, idx) {
    var index = idx + 1 + currentMonth;
    index = index > 12 ? index - 12 : index;
    var label = new Date("1999/".concat(index, "/5")).toLocaleDateString(currentLang, {
      month: 'long',
      timeZone: 'UTC'
    });
    return {
      label: label,
      index: index
    };
  });
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    events = _React$useState4[0],
    setSearchResults = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    isHidden = _React$useState6[0],
    setIsHidden = _React$useState6[1];
  var _React$useState7 = React.useState(months[0].label),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    selectedMonth = _React$useState8[0],
    setSelectedMonth = _React$useState8[1];
  var contextItem = get(fields, 'data.contextItem');
  var d = new Date();
  var getCurrentMonth = d.getMonth() + 1;

  // Resolve used conditions based on what is selected with the integrated query
  var conditions = resolveListPersonalization(intents, sitecoreContext);

  // Holder for all condition values
  var allValues = [];

  // Iterate all conditions and determine what the current user is tagged with.
  conditions && Array.isArray(conditions) && conditions.forEach(function (condition) {
    var handler = condition.handler,
      mappings = condition.mappings;
    var conditionValues = handler.getValues({
      mappings: mappings,
      sitecoreContext: sitecoreContext
    });
    if (conditionValues) {
      allValues.push.apply(allValues, _toConsumableArray(conditionValues));
    }
  });
  var _usePersonalizedList = usePersonalizedList({
      rendering: contextItem,
      route: route,
      list: events,
      conditions: [algoliaScoredCondition(allValues)]
    }),
    personalizedList = _usePersonalizedList.personalizedList,
    refreshTracking = _usePersonalizedList.refreshTracking;
  var _React$useState9 = React.useState(null),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    firstEvents = _React$useState10[0],
    setFirstEvents = _React$useState10[1];
  var _React$useState11 = React.useState(''),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    firstImage = _React$useState12[0],
    setFirstImage = _React$useState12[1];
  var _React$useState13 = React.useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    isHighlightEvent = _React$useState14[0],
    setIsHighlightEvent = _React$useState14[1];
  var _React$useState15 = React.useState(''),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    seeMoreURLTags = _React$useState16[0],
    setSeeMoreURLTags = _React$useState16[1];
  var contextItemTags = get(fields, 'data.contextItem.tags.values') || [];
  var datasourceTags = get(fields, 'data.datasource.tags.values') || [];
  var tagsList = isTagsRuleUsed ? formatTagsRuleToFilters(tagsRule) : considerPageLevelTags ? [].concat(_toConsumableArray(contextItemTags), _toConsumableArray(datasourceTags)) : datasourceTags;
  var tagsListForSeeMore = isTagsRuleUsed ? generateSeeMoreTagsFromRules(tagsRule) : get(fields, 'data.datasource') ? getTags(get(fields, 'data.datasource.tags')) : contextItemTags;
  var tagNameList = getTagsNames(tagsList, 'tags:');
  /* const tagNameList = ['tags:Sports']; */

  var tagListKey = itemTags;
  React.useEffect(function () {
    setSeeMoreURLTags(generatrURLFromTags(tagsListForSeeMore));
    var facetFilters = [];
    if (inView) {
      if (contextItemId) {
        facetFilters = ["curators.curators.Id:".concat(contextItemId)];
      }
      if (!intentsLength) {
        var _d = new Date();
        var getMonth = _d.getMonth() + 1;
        var filters = "".concat(pageFilter, " ").concat(isFilterByCurrentMonth || isInteractive ? "AND ( datesRange.to >= ".concat(Date.parse("".concat(_d.getFullYear(), "/").concat(getMonth, "/1")) / 1000, ")") : '');
        var _facetFilters = [['type:Event'], isInteractive ? ["eventMonths:".concat(getMonth)] : isFilterByCurrentMonth ? ["eventMonths:".concat(getMonth)] : [], [contextItemId ? "curators.curators.Id:".concat(contextItemId) : '']];
        var itemFilter = {
          //face
          hitsPerPage: searchCount,
          facetFilters: isTagsRuleUsed ? formatTagsRuleToFiltersOneByOne(tagsRule, _facetFilters) : [].concat(_facetFilters, [tagNameList]),
          filters: filters
        };
        getListing(indexName, itemFilter).then(function (hits) {
          hits && hits.hits.length ? setIsHidden(false) : setIsHidden(true);
          if (hits && hits.hits.length) {
            if (showFeatured && !isInteractive) {
              var _getFeaturedItemAndLi = getFeaturedItemAndList(hits.hits),
                list = _getFeaturedItemAndLi.list,
                featured = _getFeaturedItemAndLi.featured;
              setFirstEvents(featured);
              setSearchResults(list);
              setFirstImage(get(featured, 'image'));
            } else {
              setSearchResults(hits.hits);
            }
            setIsHighlightEvent(Boolean(Color));
          } else {
            // show next year events if current month has already passed in the current year
            var isNextYear = getMonth < getCurrentMonth;
            var nextMonth = isNextYear ? 1 : getMonth + 1;
            var _filters = "".concat(pageFilter, " AND (datesRange.to >= ").concat(isNextYear ? Date.parse("".concat(_d.getFullYear() + 1, "/").concat(nextMonth, "/1")) / 1000 : Date.parse("".concat(_d.getFullYear(), "/").concat(nextMonth, "/1")) / 1000, " ) AND ( datesRange.to <= ").concat(isNextYear ? new Date("".concat(_d.getFullYear() + 1, "-12-31T23:59:59Z")).getTime() / 1000 : new Date("".concat(_d.getFullYear(), "-12-31T23:59:59Z")).getTime() / 1000, ")");
            var _facetFilters2 = [['type:Event'], ["eventMonths:".concat(nextMonth)], [contextItemId ? "curators.curators.Id:".concat(contextItemId) : '']];
            itemFilter = {
              //face
              hitsPerPage: searchCount,
              facetFilters: isTagsRuleUsed ? formatTagsRuleToFiltersOneByOne(tagsRule, _facetFilters2) : [].concat(_facetFilters2, [tagNameList]),
              filters: _filters
            };
            setSelectedMonth(months[1].label);
            getListing(indexName, itemFilter).then(function (hits) {
              if (showFeatured && !isInteractive) {
                var _getFeaturedItemAndLi2 = getFeaturedItemAndList(hits.hits),
                  _list = _getFeaturedItemAndLi2.list,
                  _featured = _getFeaturedItemAndLi2.featured;
                setFirstEvents(_featured);
                setSearchResults(_list);
                setFirstImage(get(_featured, 'image'));
              } else {
                setSearchResults(hits.hits);
              }
              setIsHighlightEvent(Boolean(Color));
            });
          }
        });
      } else {
        _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          var hits, _getFeaturedItemAndLi3, list, featured;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return loadCategoryAlgoliaResults(allValues || [], ['type:Event'], searchCount, isTagsRuleUsed ? formatTagsRuleToFiltersOneByOne(tagsRule, [['type:Event']]) : tagListKey && tagListKey, [contextItemId ? "curators.curators.Id:".concat(contextItemId) : ''], currentPageID ? "NOT objectID:".concat(currentPageID) : '', indexName, true);
              case 2:
                hits = _context.sent;
                hits && hits.length ? setIsHidden(false) : setIsHidden(true);
                if (showFeatured && !isInteractive) {
                  _getFeaturedItemAndLi3 = getFeaturedItemAndList(hits), list = _getFeaturedItemAndLi3.list, featured = _getFeaturedItemAndLi3.featured;
                  setFirstEvents(featured);
                  setSearchResults(list);
                  setFirstImage(get(featured, 'image'));
                } else {
                  setSearchResults(hits);
                }
                setIsHighlightEvent(Boolean(Color));
                refreshTracking();
              case 7:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }))();
      }
    }
  }, [isPersonalised, inView]);

  //get first feature

  function isFirstFeature(items) {
    if (!showFeatured) {
      return false;
    }
    return items.featured === true;
  }
  var firstTime = true;
  var toogleDateActive = function toogleDateActive(e) {
    e.preventDefault();
    divRef.current && divRef.current.classList.toggle('active');
    tealiumClickFunc(params, 'Month Dropdown Click');
    if (firstTime) {
      firstTime = false;
      var current = get(scrollRef, 'current.scrollTop');
      current(1);
    }
  };
  var toogleDateKeyPress = function toogleDateKeyPress(e) {
    e.preventDefault();
    if (e.key === 'Enter' || e.key === 'NumpadEnter' || e.which === 32) {
      toogleDateActive(e);
    }
  };
  var handleMonthClick = function handleMonthClick(e, month, currentMonth, index) {
    e.preventDefault();
    setSelectedMonth(month);
    var currentMonthIndex = e.target.getAttribute('data-index');
    var d = new Date();

    // show next year events if current month has already passed in the current year
    var isNextYear = currentMonthIndex < getCurrentMonth;
    var filters = "".concat(pageFilter, " ").concat(currentPageID ? 'AND' : '', " (datesRange.to >= ").concat(isNextYear ? Date.parse("".concat(d.getFullYear() + 1, "/").concat(currentMonthIndex, "/1")) / 1000 : Date.parse("".concat(d.getFullYear(), "/").concat(currentMonthIndex, "/1")) / 1000, " ) AND ( datesRange.to <= ").concat(isNextYear ? new Date("".concat(d.getFullYear() + 1, "-12-31T23:59:59Z")).getTime() / 1000 : new Date("".concat(d.getFullYear(), "-12-31T23:59:59Z")).getTime() / 1000, ")");
    var facetFilters = [['type:Event'], ["eventMonths:".concat(currentMonthIndex)], [contextItemId ? "curators.curators.Id:".concat(contextItemId) : '']];
    var itemFilter = {
      hitsPerPage: searchCount,
      facetFilters: isTagsRuleUsed ? formatTagsRuleToFiltersOneByOne(tagsRule, facetFilters) : [].concat(facetFilters, [tagNameList]),
      filters: filters
    };
    getListing(indexName, itemFilter).then(function (_ref3) {
      var hits = _ref3.hits;
      hits && hits.length ? setIsHidden(false) : setIsHidden(true);
      if (showFeatured && !isInteractive) {
        var _getFeaturedItemAndLi4 = getFeaturedItemAndList(hits),
          list = _getFeaturedItemAndLi4.list,
          featured = _getFeaturedItemAndLi4.featured;
        setFirstEvents(featured);
        setSearchResults(list);
        setFirstImage(get(featured, 'image'));
      } else {
        setSearchResults(hits);
      }
      setIsHighlightEvent(Boolean(Color));
    });
    divRef.current && divRef.current.classList.remove('active');
  };
  var handleSelectChange = function handleSelectChange(e) {
    // e.preventDefault();
    var month = e.currentTarget.selectedOptions[0].innerText || '';
    setSelectedMonth(month);
    var currentMonthIndex = Number(e.currentTarget.selectedOptions[0].getAttribute('data-index'));
    var d = new Date();
    // show next year events if current month has already passed in the current year
    var isNextYear = currentMonthIndex < getCurrentMonth;
    var filters = "".concat(pageFilter, " ").concat(currentPageID ? 'AND' : '', " (datesRange.to >= ").concat(isNextYear ? Date.parse("".concat(d.getFullYear() + 1, "/").concat(currentMonthIndex, "/1")) / 1000 : Date.parse("".concat(d.getFullYear(), "/").concat(currentMonthIndex, "/1")) / 1000, " ) AND ( datesRange.to <= ").concat(isNextYear ? new Date("".concat(d.getFullYear() + 1, "-12-31T23:59:59Z")).getTime() / 1000 : new Date("".concat(d.getFullYear(), "-12-31T23:59:59Z")).getTime() / 1000, ")");
    var facetFilters = [['type:Event'], ["eventMonths:".concat(currentMonthIndex)], [contextItemId ? "curators.curators.Id:".concat(contextItemId) : '']];
    var itemFilter = {
      hitsPerPage: searchCount,
      facetFilters: isTagsRuleUsed ? formatTagsRuleToFiltersOneByOne(tagsRule, facetFilters) : [].concat(facetFilters, [tagNameList]),
      filters: filters
    };
    getListing(indexName, itemFilter).then(function (_ref4) {
      var hits = _ref4.hits;
      hits && hits.length ? setIsHidden(false) : setIsHidden(true);
      if (showFeatured && !isInteractive) {
        var _getFeaturedItemAndLi5 = getFeaturedItemAndList(hits),
          list = _getFeaturedItemAndLi5.list,
          featured = _getFeaturedItemAndLi5.featured;
        setFirstEvents(featured);
        setSearchResults(list);
        setFirstImage(get(featured, 'image'));
      } else {
        setSearchResults(hits);
      }
      setIsHighlightEvent(Boolean(Color));
    });
  };
  var renderMonths = function renderMonths() {
    return months.map(function (month, index) {
      return /*#__PURE__*/React.createElement("li", {
        tabIndex: 0,
        key: index,
        "data-index": month.index,
        className: "select-item to-capitalize ".concat(selectedMonth === month.label ? 'select-item--selected' : ''),
        onClick: function onClick(e) {
          handleMonthClick(e, month.label, currentMonth, index);
          tealiumClickFunc(params, "Month Selection : ".concat(month.label));
        },
        onKeyPress: function onKeyPress(e) {
          e.preventDefault();
          if (e.key === 'Enter' || e.key === 'NumpadEnter' || e.which === 32) {
            handleMonthClick(e, month.label, currentMonth, index);
            tealiumClickFunc(params, "Month Selection : ".concat(month.label));
          }
        }
      }, month.label);
    });
  };
  var renderSelectMonths = function renderSelectMonths() {
    return months.map(function (month, index) {
      return /*#__PURE__*/React.createElement("option", {
        "data-index": month.index,
        className: "to-capitalize",
        value: month.label,
        key: index
      }, month.label);
    });
  };
  var renderFeatureItem = function renderFeatureItem() {
    if (firstEvents && showFeatured) {
      var imgSrc = injectImageResolution("".concat(pathJoin([getMediaHost(), firstImage])), 700, 428);
      var imgSrcMob = injectImageResolution("".concat(pathJoin([getMediaHost(), firstImage])), 325, 300);
      return /*#__PURE__*/React.createElement("div", {
        className: "events__featured-block events__featured-block--highlighted ".concat(theme ? 'brand-bg' : '')
      }, /*#__PURE__*/React.createElement(ScrollAnimation, {
        className: "events__featured__bg-animate",
        animateIn: "animate__slideInRight",
        animateOnce: true,
        duration: 1,
        offset: 150
      }, /*#__PURE__*/React.createElement("div", {
        className: "events__featured__bg-color ".concat(Color ? Color : 'base')
      })), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xl-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-xl-11"
      }, !isInteractive && /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1
      }, /*#__PURE__*/React.createElement("div", {
        className: "events__title-block"
      }, titleEventCheck ? /*#__PURE__*/React.createElement(Text, {
        tag: "h2",
        className: "events__title",
        field: titleEvent
      }) : /*#__PURE__*/React.createElement("h2", {
        className: "events__title"
      }, defaultTitle)), ' '))), overviewButton ? /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1,
        delay: 100
      }, /*#__PURE__*/React.createElement(FeaturedEventBlock, {
        event: firstEvents,
        curatorsCopy: curatorsPickCopy,
        lang: currentLang,
        multipleDates: multipleDates,
        hostLink: overviewButton.link.jss.value.href + curtorListingPage,
        analytics: {
          eventsAnalytics: eventsAnalytics,
          params: params
        },
        countryItems: countryItems,
        themeValues: Object.values(styleThemeHexColor)
      })) : null);
    } else {
      return /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xl-1"
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-xl-11"
      }, !isInteractive && /*#__PURE__*/React.createElement(ScrollAnimation, {
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1
      }, /*#__PURE__*/React.createElement("div", {
        className: "events__title-block"
      }, /*#__PURE__*/React.createElement(Text, {
        tag: "h2",
        className: "events__title",
        field: titleEvent
      })))));
    }
  };
  var renderItems = function renderItems() {
    var itemsToMap = searchCount;
    if (isNil(overviewButton)) {
      return [];
    }
    return validateItems.slice(0, itemsToMap).map(function (event, index) {
      return /*#__PURE__*/React.createElement(ScrollAnimation, {
        style: {
          height: "97%"
        },
        animateIn: "animate__fadeInUp",
        animateOnce: true,
        duration: 1 + index / 3
      }, /*#__PURE__*/React.createElement(EventBlock, {
        key: index,
        event: event && event.item ? event.item : event,
        curatorsCopy: curatorsPickCopy,
        lang: currentLang,
        multipleDates: multipleDates,
        hostLink: overviewButton.link.jss.value.href + curtorListingPage,
        analytics: {
          eventsAnalytics: eventsAnalytics,
          params: params
        },
        countryItems: countryItems,
        themeValues: Object.values(styleThemeHexColor),
        inSlider: true
      }));
    });
  };
  var validateItems = intentsLength && isPersonalised ? personalizedList : events;
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    isHidden: true,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    ref: ref
  }, /*#__PURE__*/React.createElement("div", {
    className: "container m15-events",
    style: styleThemeHexColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, renderFeatureItem())), /*#__PURE__*/React.createElement("div", {
    className: "container m15-events ",
    style: styleThemeHexColor
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, isInteractive && /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12 offset-xl-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__title-block"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1
  }, /*#__PURE__*/React.createElement("div", {
    className: "h2 events__title events__interactive-title c__title"
  }, upcomingEventsIn && /*#__PURE__*/React.createElement(Text, {
    className: "span",
    tag: "span",
    field: upcomingEventsIn
  }), /*#__PURE__*/React.createElement("div", {
    className: "events__dd-wrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btn btn-tertiary btn-select cc__custom-dd",
    tabIndex: 0,
    onClick: toogleDateActive,
    onKeyPress: toogleDateKeyPress
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn-tertiary__text to-capitalize"
  }, selectedMonth), /*#__PURE__*/React.createElement(ChevronDown, {
    className: "btn-tertiary__icon btn-link__icon btn-link-icon"
  }), /*#__PURE__*/React.createElement("div", {
    className: "section__select-mob"
  }, /*#__PURE__*/React.createElement("label", {
    className: "accessibility-hidden-text",
    htmlFor: "select_dd1"
  }, upcomingEventsIn && upcomingEventsIn.value), /*#__PURE__*/React.createElement("select", {
    className: "select_form",
    id: "select_dd1",
    onChange: handleSelectChange
  }, renderSelectMonths()))), /*#__PURE__*/React.createElement("div", {
    className: "section__select",
    "data-index": "1",
    ref: divRef
  }, /*#__PURE__*/React.createElement("ul", {
    className: "select-location months"
  }, /*#__PURE__*/React.createElement(Scrollbars, {
    ref: scrollRef,
    style: {
      width: 197,
      height: 285
    },
    renderTrackHorizontal: function renderTrackHorizontal(props) {
      return /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "track-horizontal"
      }));
    },
    renderTrackVertical: function renderTrackVertical(props) {
      return /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "track-vertical"
      }));
    },
    renderThumbHorizontal: function renderThumbHorizontal(props) {
      return /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "thumb-horizontal"
      }));
    },
    renderThumbVertical: function renderThumbVertical(props) {
      return /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "thumb-vertical"
      }));
    },
    renderView: function renderView(props) {
      return /*#__PURE__*/React.createElement("div", _extends({}, props, {
        className: "view"
      }));
    }
  }, renderMonths()))))))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(isInteractive ? '' : '', " events__items-carousel row ")
  }, validateItems && validateItems.length > 0 ? /*#__PURE__*/React.createElement(CarouselProvider, null, function (_ref5) {
    var renderCarousel = _ref5.renderCarousel,
      renderPreviousButton = _ref5.renderPreviousButton,
      renderNextButton = _ref5.renderNextButton,
      renderDots = _ref5.renderDots,
      state = _ref5.state;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-xl-9 offset-xl-1 ".concat(rtl && get(state, 'slidesToShow') >= get(state, 'totalItems') ? 'item-rtl-carousal-fix' : '', " ")
    }, renderCarousel(renderItems(), {
      responsive: {
        desktop: {
          breakpoint: {
            max: 10000,
            min: 768
          },
          items: 3
        },
        tablet: {
          breakpoint: {
            max: 767,
            min: 480
          },
          items: 2
        },
        mobile: {
          breakpoint: {
            max: 479,
            min: 0
          },
          items: 1
        }
      },
      containerClass: 'row events__items-row remove-padding-mobile'
    }, function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['mobileSlidesAnalytics'], params));
    })), /*#__PURE__*/React.createElement("div", {
      className: "events-pagination__btn btn-group--left ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderPreviousButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['prevNextNavAnalytics'], params));
    })), /*#__PURE__*/React.createElement("div", {
      className: "events-pagination__btn btn-group--right ".concat(rtl ? 'btn-group-rtl' : '')
    }, renderNextButton(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['prevNextNavAnalytics'], params));
    })), /*#__PURE__*/React.createElement("div", {
      className: "events-pagination__dots"
    }, renderDots(function () {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['navBubblesAnalytics'], params));
    })));
  }) : isInteractive && isHidden && /*#__PURE__*/React.createElement("div", {
    className: "col-12 offset-xl-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "no-events"
  }, /*#__PURE__*/React.createElement("h4", {
    className: "no-events__message"
  }, getDictionaryItem(moduleDictionary, 'no events in this month'))))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-xl-11"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1,
    delay: 200
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__more-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-none d-md-block"
  }, overviewButton && overviewButtonTitle && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    className: "btn btn-link",
    href: discoverMoreLink + curtorListingPage + seeMoreURLTags,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['seeMoreAnalytics'], params));
    }
  }, /*#__PURE__*/React.createElement(Text, {
    className: "btn-link__text",
    tag: "span",
    field: overviewButtonTitle
  }), rtl ? /*#__PURE__*/React.createElement(ChevronLeft, {
    className: "btn-link__icon btn-link-icon"
  }) : /*#__PURE__*/React.createElement(ChevronRight, {
    className: "btn-link__icon btn-link-icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "d-md-none rs_skip"
  }, overviewButton && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: overviewButton.link.jss.value.href + curtorListingPage + seeMoreURLTags,
    onClick: function onClick() {
      return tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['seeMoreAnalytics'], params));
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: "btn btn-primary"
  }, overviewButton.title.jss.value)))))))))));
};
var StyledWrapper = function StyledWrapper(_ref6) {
  var children = _ref6.children,
    rtl = _ref6.rtl,
    isHidden = _ref6.isHidden,
    anchorUrlParameter = _ref6.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(React.Fragment, null, !(isHidden !== undefined && !isHidden) ? /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    minHeight: true
    /* className={`${commonStyles} ${rtl ? rtlStyles : ltrStyles}  ${commonoFocusEvent} ${ColorsLogic}`} */,
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles, " ").concat(ColorsLogic)
  }, children) : null, ' ');
};
var ColorsLogic = "c1as7mzs";
/* const commonoFocusEvent = css`
  .events__interactive-title .cc__custom-dd:focus {
    outline: none;
  }
`; */

export var commonStyles = "c1ue9rtw";
var ltrStyles = "l1ruemiz";
var rtlStyles = "r1fklu25";
export default Events;